<template>
  <div>
    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column prop="date" label="序号" width="80" align="center">
        <template slot-scope="scope">
          <div>
            {{ scope.$index + 1 }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="指标(万元)" align="center">
      </el-table-column>

      <el-table-column
        v-for="(col, index) in yearsList"
        :key="index"
        align="center"
      >
        <template slot="header" slot-scope="scope">
          <div>
            <span>年份{{ col.value }}</span>
          </div>
        </template>
        <template slot-scope="scope">
          <span v-if="scope.row.dataList[index]">{{
            scope.row.dataList[index].num
          }}</span>
          <!-- <el-form :model="scope.row" :rules="rules" size="small" inline>
            <el-form-item
              :key="scope.row.dataList[index].label"
              label=""
              :prop="'dataList.' + index + '.num'"
              :rules="{
                required: true,
                message: '数据不能为空',
                trigger: 'blur',
              }"
            >
              <el-input v-model="scope.row.dataList[index].num"></el-input>
            </el-form-item>
          </el-form> -->
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    companyData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      yearsList: [],
      tableData: [
        {
          name: '总资产',
          num: null,
          label: 'totalAssets',
          dataList: [],
        },
        {
          name: '营业收入',
          num: null,
          label: 'operatingRevenue',
          dataList: [],
        },
        {
          name: '流动资产',
          num: null,
          label: 'currentAssets',
          dataList: [],
        },
        {
          name: '总负债',
          num: null,
          label: 'totalLiabilities',
          dataList: [],
        },
        {
          name: '流动负债',
          num: null,
          label: 'currentLiabilities',
          dataList: [],
        },
        {
          name: '固定资产原值',
          num: null,
          label: 'fixedAssetsOriginalValue',
          dataList: [],
        },
        {
          name: '固定资产期末净值',
          num: null,
          label: 'fixedAssetsNetValue',
          dataList: [],
        },
        {
          name: '流动资金期末净值',
          num: null,
          label: 'currentAssetsNetValue',
          dataList: [],
        },
        {
          name: '净利润',
          num: null,
          label: 'netProfit',
          dataList: [],
        },
        {
          name: '利润率%',
          num: null,
          label: 'profitMargin',
          dataList: [],
        },
        {
          name: '营业毛利率%',
          num: null,
          label: 'operatingMargin',
          dataList: [],
        },
        {
          name: '资产负债率%',
          num: null,
          label: 'assetLiabilityRatio',
          dataList: [],
        },
        {
          name: '流动比率%',
          num: null,
          label: 'currentRatio',
          dataList: [],
        },
        {
          name: '对外担保金额',
          num: null,
          label: 'externalGuaranteeAmount',
          dataList: [],
        },
      ],
    };
  },
  created() {
    console.log(this.companyData);
    this.getYearsList();
    this.getData();
  },
  methods: {
    getData() {
      this.tableData.forEach((item) => {
        this.companyData.forEach((item2) => {
          const obj = {};
          obj.label = item2.year;
          console.log(item2[item.label]);
          obj.num = Number(item2[item.label]).toFixed(2);
          item.dataList.push(obj);
        });
      });
      console.log(this.tableData);
      // return data;
    },

    getYearsList() {
      this.companyData.forEach((item) => {
        this.yearsList.push({
          label: '年份',
          value: item.year,
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-group {
  display: flex;
  flex-flow: row;
  margin: 20px 0 10px 0;
}
::v-deep.el-table .cell {
  font-size: 14px;
}
</style>
